module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "divvmoney",
    staticClass: "prefix input-group input-group--text-field input-group--prefix primary--text"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('span', {
    staticClass: "input-group--text-field__prefix"
  }, [_vm._v("R$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: ({
        precision: _vm.precision,
        decimal: _vm.decimal,
        thousands: _vm.thousands,
        prefix: _vm.prefix,
        suffix: _vm.suffix
      }),
      expression: "{precision, decimal, thousands, prefix, suffix}"
    }],
    ref: "inputvmoney",
    attrs: {
      "tabindex": "0",
      "aria-label": _vm.label,
      "type": "tel",
      "required": _vm.validation
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "change": _vm.change,
      "focus": _vm.onFocusApplyDirtClass,
      "blur": _vm.applyClasseDirtAndFocus
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input-group__details"
  }, [(_vm.errorMessage) ? _c('div', {
    staticClass: "input-group__messages input-group__error"
  }, [_vm._v("\n        Insira um valor\n      ")]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d90f3a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/v-money/component.vue
// module id = 352
// module chunks = 43